<ion-content class="marv_list">
        
    @if(this.withSearch){
        <form class="marv_list_search ion-padding-horizontal" [formGroup]="this.searchForm">
            <ion-grid class="no_padding">
                <ion-row class="ion-align-items-center">
                    <ion-col class="no_padding">
                        <marv-input type="text" label="{{'SEARCH' | translate}}" icon="search-outline" formName="search" [showBtnClearInput]="true" [withSpeechToText]="true"/>                    
                    </ion-col>
                    @if(this.multiple){
                        <ion-col class="no_padding" size="auto">
                            @if(this.allSelected){
                                <marv-button type="button" label="{{'UNSELECT_ALL' | translate}}" color="primary" (click)="this.unselectAll()" />
                            }
                            @else{
                                <marv-button type="button" label="{{'SELECT_ALL' | translate}}" color="primary" (click)="this.selectAll()" />
                            }
                        </ion-col>
                    }
                </ion-row>
            </ion-grid>
        </form>
    }
         
    <div class="ion-padding-horizontal">    
        
        @if(this.isFetching){
            <div class="bloc_loading">
                <ion-spinner></ion-spinner>
            </div>        
        }
        @else{
            
            @if(this.itemsDisplayed.length === 0){        
                <marv-message type="info">{{'MSG_NO_DATA' | translate}}</marv-message>       
            }
            @else{               
                @for(item of this.itemsDisplayed; track $index){
                    <marv-item (click)="this.selectItem(item)">
                        <div class="item_list">
                            @if(item.picture){
                                <ion-avatar slot="start">
                                    <img [src]="item.picture" />
                                </ion-avatar>
                            }
                            
                            @if(this.displayItemsColors){
                                <div class="item_color" [class]="item.color"></div>
                            }
                            <ion-label>{{item.label}}</ion-label>  
                            
                            @if(this.itemsSelectedCopy.get(item.value)){
                                <ion-icon class="icon_item_checked" name="checkmark-outline"></ion-icon>
                            }
                        </div>
                    </marv-item>            
                }
                
                <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
                    <ion-infinite-scroll-content loading-spinner="dots"></ion-infinite-scroll-content>
                </ion-infinite-scroll> 
            }

        }
    </div>
</ion-content>
